





















































import { Component, Model, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { GapReportFilter,GapFilter } from "@/store/modules/types";

@Component({
  computed: mapState("gaps", ["ipas","campaigns"])
})
export default class YearlyStatusSearch extends Vue {
  @Model("change") readonly filter!: GapReportFilter;
}
